import { Link, LinkPropsType } from "@tanstack/react-location"
import { ForwardedRef, forwardRef } from "react"

const LinkWithForwardRef = (props: Omit<LinkPropsType, "_ref">, ref: ForwardedRef<null>) => (
  <Link {...props} _ref={ref} />
)

export default forwardRef(LinkWithForwardRef)
